import * as React from 'react';
import * as styles from './styles.css';

import { Container } from '../../Container';
import { Text } from '../../Text';

export function Thanks() {
  return (
    <div className={styles['container']}>
      <Container>
        <div className={styles['title']}>
          <Text size="h2" color="white" bold>
            Заявка оформлена!
          </Text>
        </div>
        <div className={styles['description']}>
          <Text color="white">Мы позвоним вам в ближайшее время</Text>
        </div>
      </Container>
    </div>
  );
}
